import React from 'react';

const PointerCircle = () => <div className="pointer-circle" />;

export default PointerCircle;
